module.exports = __webpack_public_path__ + "img/calapan-circulation.6e7c1656.jpg";